import { LagDateBadge } from 'components/LagDateBadge/LagDateBadge';

/**
 * Lag Date Column Cell Formatter
 * @param props
 * @returns
 */
export const CellLagDate = (props: any, defaultLagDate?: string) => {
  const {
    row: { original },
  } = props;

  return (
    <div style={{ textAlign: 'left' }}>
      {LagDateBadge({
        isLagged: original.isLagged,
        defaultLagDate: defaultLagDate,
        customLagDate: original.customLagDate,
      })}
    </div>
  );
};
